// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"ad3c387c","459":"ae2ae936","614":"22e05efb","648":"7f8f8bfd","929":"56ad53d7"}[chunkId] + ".chunk.js";
};